// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3pn9s","inputs":"styles_inputs__2dklX","input":"styles_input__3SQWo","fullInput":"styles_fullInput__2kTXt"};